import React from 'react'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import classes from "./style.module.scss";

const ScrollableTable = (props) => {

    const {
        headerDetails = [],
        listLength = [],
        isLoading = false,
        highlightRows = false,
        tableSort = false,
        autoHeight = false,
        sortedColumns = '',
        setSortedColumns,
    } = props

    const handleSort = (key) => {
        if (sortedColumns?.key === key) {
            setSortedColumns({ key: key, direction: sortedColumns?.direction === 'asc' ? 'desc' : 'asc' })
        } else {
            setSortedColumns({ key: key, direction: 'desc' })
        }
    };

    return (
        <div className={`${classes.scrollableTableWrapper} ${highlightRows ? classes.highlight : ''}`}>
            <div className={`${classes.scrollableTable}`}>
                <div className={`${classes.tableHeader} flex items-center`}>
                    {headerDetails.map(({ label, sortable = false }) => (
                        <div key={label} className={`flex items-center justify-center text-center h-[100%] w-[50%]`}
                            onClick={() => (tableSort && listLength.length !== 0 && sortable) ? handleSort(sortable) : null}>
                            <div>{label}</div>
                            {/* {(tableSort && listLength.length !== 0 && sortable && sortedColumns?.key === sortable) ? */}
                            {(tableSort && listLength.length !== 0 && sortable) ?
                                <span>
                                    <ArrowForwardIosSharpIcon className={`${classes.sortingArrow} ${(sortedColumns && sortedColumns?.key === sortable && sortedColumns?.direction === 'desc') ? classes.arrowActive : ''}`} />
                                </span> : null
                            }
                        </div>
                    ))}
                </div>
                <div className={`${classes.tableBody} ${autoHeight ? `!h-[auto]` : ''}`}>
                    {isLoading ? (
                        <div className='h-[100%] w-[100%] fs-20 py-4 flex items-center justify-center'>Loading...</div>
                    ) :
                        listLength.length !== 0 ? (
                            props.children
                        ) : (
                            <p className="h-[100%] w-[100%] fs-20 py-4 flex items-center justify-center">
                                No records found !!!
                            </p>
                        )
                    }
                </div>

            </div>
        </div>
    )
}

export default ScrollableTable